import Cookies from 'universal-cookie'
import jwt from 'jsonwebtoken'
import handlePromise from 'utils/handle-promise'

const hostname = process.env.API_HOST || 'https://api.learning.rest'

export async function getUserProfileService({ token }) {
  const data = await handlePromise('/api/v1/me/profile/', {
    headers: {
      Authorization: token,
    },
    method: 'GET',
  })
  return data
}

export async function getPortfolioService({ username, token, is_ssg }) {
  const query = is_ssg ? '?is_ssg=true' : ''
  const data = await handlePromise(`/api/v1/users/${username}/${query}`, {
    method: 'GET',
    headers: { Authorization: token },
  })
  return data
}

export async function getPersonalProjectsService({ token }) {
  const data = await handlePromise('/api/v1/portfolio-projects/', {
    method: 'GET',
    headers: { Authorization: token },
  })
  return data
}

export async function getSocialMedia({ token }) {
  const data = await handlePromise('/api/v1/me/social-media/', {
    headers: {
      Authorization: token,
    },
    method: 'GET',
  })
  return data
}

export async function getFavoritesService({ token }) {
  const data = await handlePromise('/api/v1/me/favorites/', {
    headers: {
      Authorization: token,
    },
    method: 'GET',
  })
  return data
}

export async function updateProfileService({ token, payload }) {
  const data = await handlePromise('/api/v1/me/profile/', {
    headers: {
      Authorization: token || null,
    },
    method: 'PUT',
    body: payload,
  })
  const {
    email, first_name, last_name, photo, lang, is_active,
  } = data
  const cookies = new Cookies()
  const now = new Date()
  const sevenDaysFromNow = now.setDate(now.getDate() + 7)
  const options = { expires: new Date(sevenDaysFromNow), path: '/' }
  const profile = {
    email, first_name, last_name, photo, lang, is_active,
  }
  cookies.set('user_payload', jwt.sign(profile, 'secret'), options)
  return data
}

export async function updatePasswordService({ token, payload }) {
  const data = await handlePromise('/api/v1/me/password/', {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: token || null,
    },
    method: 'PUT',
    body: JSON.stringify(payload),
  })
  return data
}

export async function createPasswordService({ token, payload }) {
  const data = await handlePromise('/api/v1/me/password/', {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: token || null,
    },
    method: 'POST',
    body: JSON.stringify(payload),
  })
  return data
}

export async function updateConfigService({ token, payload }) {
  const data = await handlePromise('/api/v1/me/config/', {
    headers: {
      Authorization: token || null,
    },
    method: 'PUT',
    body: payload,
  })
  return data
}

export async function updateDiscordUsernameService({ token, payload }) {
  try {
    const response = await fetch(`${hostname}/api/v1/me/discord/`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: token,
      },
      method: 'POST',
      body: JSON.stringify(payload),
    })
    const data = await response.json()
    if (!response.ok) {
      const errorMessage = data.discord_username[0]
      return {
        error: true,
        ...errorMessage,
      }
    }
    return data
  } catch (err) {
    console.error(err)
    return { error: true }
  }
}

export async function updateGithubUsernameService({ token, payload }) {
  try {
    const response = await fetch(`${hostname}/api/v1/me/github/`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: token,
      },
      method: 'POST',
      body: JSON.stringify(payload),
    })
    const data = await response.json()
    if (!response.ok) {
      const errorMessage = data.github_username[0]
      return {
        error: true,
        ...errorMessage,
      }
    }
    return data
  } catch (err) {
    console.error(err)
    return { error: true }
  }
}

export async function unlinkGithubService({ token }) {
  const data = await handlePromise('/api/v1/me/github/', {
    headers: { Authorization: token },
    method: 'DELETE',
  })
  return data
}

export async function unlinkDiscordService({ token }) {
  const data = await handlePromise('/api/v1/me/discord/', {
    headers: { Authorization: token },
    method: 'DELETE',
  })
  return data
}
